"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationStatus = void 0;
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["SENDING_STARTED"] = "SENDING_STARTED";
    NotificationStatus["SENDING_SUCCEEDED"] = "SENDING_SUCCEEDED";
    NotificationStatus["SENDING_FAILED"] = "SENDING_FAILED";
})(NotificationStatus = exports.NotificationStatus || (exports.NotificationStatus = {}));
